module.exports = __webpack_public_path__ + "img/sab (1).35b0cefc.svg";